import { render, staticRenderFns } from "./PsCommitmentsDashboard.vue?vue&type=template&id=796cd5f3&scoped=true"
import script from "./PsCommitmentsDashboard.vue?vue&type=script&lang=js"
export * from "./PsCommitmentsDashboard.vue?vue&type=script&lang=js"
import style0 from "./PsCommitmentsDashboard.vue?vue&type=style&index=0&id=796cd5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cd5f3",
  null
  
)

export default component.exports